// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xBaseTheme } from "@ces/XDL/types";
import { color } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export const childrenSelector = `& > ${TypographyStyle}, & > ${IconWrapper}`;

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        mergeCss: true,
        color: "text.link",
        typographyProps: {
            size: 12,
            weight: fontConfig.weight.bold,
            transform: "capitalize",
            css: css`
                letter-spacing: 0;
                line-height: 19px;
            `,
        },
        css: css`
            display: inline-flex;
            gap: 8px;
            align-items: center;
            width: fit-content;
            & > ${IconWrapper} {
                margin: 0;
                opacity: 0.66;
            }
            &:not(:disabled):visited {
                ${childrenSelector} {
                    color: ${color("text.visited")};
                }
            }
            &:not([disabled]):hover,
            &:not([disabled]):focus {
                ${childrenSelector} {
                    color: ${color("common.ui8")};
                }
                outline: none;
            }
            &[disabled] {
                opacity: 0.44;
                cursor: not-allowed;
                ${childrenSelector} {
                    color: ${color("text.link")};
                }
            }
        `,
    },
} as xBaseTheme["link"];
